export default {
  'fr-FR': {
    currency: {
      style: 'currency', currency: 'EUR'
    }
  },
  'en-US': {
    currency: {
      style: 'currency', currency: 'USD'
    }
  }
}
